"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DataSecureIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.641 11.652a5.894 5.894 0 00-.344 1.996v.602h-.031c-.72 0-1.34.397-1.615.967-4.53-.106-8.129-1.48-8.219-3.172L2.431 9.93h.006c.022-.202.1-.398.229-.588.915 1.347 4.395 2.35 8.55 2.35.485 0 .961-.014 1.425-.04zM10.5 20.51c-4.47-.133-7.996-1.502-8.068-3.18l-.001-2.114h.006c.022-.201.1-.398.229-.587.862 1.268 4 2.231 7.834 2.339v3.542z",
    opacity: ".6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.992 4.628H20v2.19c0 1.784-3.933 3.23-8.785 3.23-4.851 0-8.784-1.446-8.784-3.23v-2.19h.008c.203-1.624 4.055-2.92 8.776-2.92 4.722 0 8.574 1.296 8.777 2.92z",
    opacity: ".8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.5 15h.375c.621 0 1.125.485 1.125 1.083v4.334c0 .598-.504 1.083-1.125 1.083h-6.75c-.621 0-1.125-.485-1.125-1.083v-4.334c0-.598.504-1.083 1.125-1.083h.375v-1.561c0-1.623 1.343-2.939 3-2.939s3 1.316 3 2.939V15zM18 15v-1.476c0-.842-.672-1.524-1.5-1.524s-1.5.682-1.5 1.524V15h3z"
  })));
});
DataSecureIcon.category = 'Content';
var _default = DataSecureIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/DataSecureIcon.js
// module id = 1068
// module chunks = 0